import React from 'react'
import { Menu as AntdMenu, Dropdown } from 'antd'
import { Link, withRouter } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { MenuWrapper, MenuButton } from './styles'
import { AkaTypography } from 'components'
import { MenuOutlined, SettingOutlined } from '@ant-design/icons'
import { ROUTES } from 'modules/navigation'
import { useUser } from 'providers'
import userIcon from 'img/profile-user.svg'

const styles = {
	user: { margin: '0 0 0 16px' },
	icon: { marginRight: 8, marginBottom: 4 },
	menu: { fontSize: 24 },
	settings: { fontSize: 16, margin: '0 16px', color: 'white' }
}

const OVERLAY_MENU_ITEMS = [
	{
		key: 'securityIncident',
		name: 'outreach.menu',
		type: 'link',
		testId: 'security-incident-item',
		to: ROUTES.securityIncident
	},
	{
		key: 'contact',
		name: 'Kontakt',
		type: 'link',
		testId: 'contact-item',
		to: ROUTES.contact
	},
	{ key: 'help', name: 'Hilfe', type: 'download', testId: 'help-item' },
	{ key: 'faq', name: 'FAQ', type: 'link', testId: 'faq-item', to: ROUTES.faq },
	{
		key: 'imprint',
		name: 'Impressum',
		type: 'link',
		testId: 'impressum-item',
		to: ROUTES.imprint
	},
	{
		key: 'sealTerms',
		name: 'HZV-Prüfsiegel-Bestimmungen',
		type: 'link',
		testId: 'sealTerms-item',
		to: ROUTES.sealTerms
	},
	{
		key: 'privacyPolicy',
		name: 'Datenschutzerklärung',
		type: 'link',
		testId: 'privacyPolicy-item',
		to: ROUTES.privacyPolicy
	},
	{
		key: 'termsOfUse',
		name: 'Nutzungsbedingungen',
		type: 'link',
		testId: 'termsOfUse-item',
		to: ROUTES.termsOfUse
	},
	{ key: 'logout', name: 'Abmelden', type: 'button', testId: 'logout-item' }
]

const Menu = () => {
	const [t] = useTranslation()
	const { user, isAuthenticated, loadingAuth, loadingVerify, logout } =
		useUser()
	const label = item =>
		item.key === 'securityIncident' ? t(item.name) : item.name
	const menu = (
		<AntdMenu
			onClick={event => event.key === 'logout' && logout()}
			items={OVERLAY_MENU_ITEMS.map(item => ({
				label: (
					<div data-testid={item.testId}>
						{item.type === 'download' && isAuthenticated && (
							<a
								download="Hilfsdatei"
								href={`${user.helpFile}`}
								target="_blank"
								rel="noopener noreferrer"
							>
								<AkaTypography variant="bodySegoe2">
									{label(item)}
								</AkaTypography>
							</a>
						)}
						{item.type === 'link' && (
							<Link to={item.to} rel="noopener noreferrer">
								<AkaTypography variant="bodySegoe2">
									{label(item)}
								</AkaTypography>
							</Link>
						)}
						{item.type === 'button' && (
							<AkaTypography variant="bodySegoe2">{label(item)}</AkaTypography>
						)}
					</div>
				),
				key: item.key
			}))}
		/>
	)

	return (
		<MenuWrapper data-testid="main-menu" style={styles.wrapper}>
			{isAuthenticated && !loadingAuth && !loadingVerify && (
				<>
					<AkaTypography
						style={styles.user}
						variant="bodySegoe2"
						data-testid="user-data"
						color="white"
					>
						<img
							style={styles.icon}
							src={userIcon}
							height={18}
							alt="user-icon"
						/>
						{`${user.firstName.replace(/^\w/, c => c.toUpperCase())} ${user.lastName.replace(/^\w/, c => c.toUpperCase())}`}
					</AkaTypography>
					<Link to={ROUTES.account.base} style={styles.settingsLink}>
						<SettingOutlined style={styles.settings} />
					</Link>
				</>
			)}
			<Dropdown overlay={menu} placement="bottomLeft" trigger={['click']}>
				<MenuButton type="primary" size="default" data-testid="burger-button">
					<MenuOutlined style={styles.menu} />
				</MenuButton>
			</Dropdown>
		</MenuWrapper>
	)
}

export default withRouter(Menu)
